import Constants from 'config/Constants';
import { useTranslation } from 'react-i18next';
import { Badge } from 'components/Badge';

export function BlockType({ block, isInsideBlockLayout = false }) {
    const { type, properties = {} } = block;
    const { textLayout = 'default' } = properties;
    const { t } = useTranslation('documents');

    if (type === Constants.blockTypes.blockLayout && properties.type === Constants.blockTypes.textExplanation) {
        return (
            <Badge variant="light" className="mr-1">
                {t('document.navbar.main.editor.left.blocks.badges.blockType.textWithExplanation')}
            </Badge>
        );
    }

    const blockTypeNames = {
        [Constants.blockTypes.text]: t('document.navbar.main.editor.left.blocks.badges.blockType.text'),
        [Constants.blockTypes.file]: t('document.navbar.main.editor.left.blocks.badges.blockType.image'),
        [Constants.blockTypes.label]: t('document.navbar.main.editor.left.blocks.badges.blockType.options'),
        [Constants.blockTypes.table]: t('document.navbar.main.editor.left.blocks.badges.blockType.table'),
        [Constants.blockTypes.reimbursement]: t('document.navbar.main.editor.left.blocks.badges.blockType.package'),
        [Constants.blockTypes.blockLayout]: t('document.navbar.main.editor.left.blocks.badges.blockType.tableLayout'),
        [Constants.blockTypes.linked]: t('document.navbar.main.editor.left.blocks.badges.blockType.linked'),
    };

    const blockLayoutNames = {
        default: t('document.navbar.main.editor.left.blocks.badges.blockType.text'),
        intro: t('document.navbar.main.editor.left.blocks.badges.blockType.introtext'),
        attention: t('document.navbar.main.editor.left.blocks.badges.blockType.attention'),
        info: t('document.navbar.main.editor.left.blocks.badges.blockType.info'),
        'more-info': t('document.navbar.main.editor.left.blocks.badges.blockType.moreInfo'),
        special: t('document.navbar.main.editor.left.blocks.badges.blockType.special'),
        action: t('document.navbar.main.editor.left.blocks.badges.blockType.action'),
    };

    const text = type === Constants.blockTypes.text ? blockLayoutNames[textLayout] : blockTypeNames[type];

    if (isInsideBlockLayout && text === t('document.navbar.main.editor.left.blocks.badges.blockType.text')) {
        return null; // Return null to prevent rendering the ToolbarLabel
    }

    return (
        <Badge variant="light" className="mr-1">
            {text ?? t('document.navbar.main.editor.left.blocks.badges.blockType.unknown')}
        </Badge>
    );
}
